// MODÜL 14: ACİL DURUM PROSEDÜRLERİ

const cabinCrewContentsM14 = {
  // ==================== TAHLİYE ====================
  'CM-M14-U1-L1': {
    lesson_id: 'CM-M14-U1-L1',
    title: 'Tahliye Türleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Acil Tahliye Türleri',
      paragraphs: [
        'Planned Evacuation: Önceden planlanmış. Kaptan talimatıyla. Daha kontrollü.',
        'Unplanned Evacuation: Ani karar. Yangın, duman gibi durumlarda. Hızlı tepki gerekir.',
        'Land Evacuation: Karada tahliye. Slide kullanılır.',
        'Water Ditching: Su üzerine iniş. Raft (sal) kullanılır.',
        '90 Saniye Kuralı: Tüm yolcular 90 saniyede tahliye edilebilmeli. Yasal zorunluluk.'
      ],
      keyPoints: [
        'Planned vs Unplanned',
        'Land vs Water',
        '90 saniye kuralı',
        'Slide vs Raft'
      ]
    }
  },
  'CM-M14-U1-L2': {
    lesson_id: 'CM-M14-U1-L2',
    title: 'Komutlar ve İletişim',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Tahliye Komutları',
      paragraphs: [
        'BRACE! BRACE!: Darbe pozisyonu al. Baş dizlere, eller başın arkasında.',
        'EVACUATE! EVACUATE!: Tahliye başlasın. Kapılar açılır.',
        'THIS WAY! COME THIS WAY!: Yolcuları yönlendirme. El hareketleriyle destekle.',
        'LEAVE EVERYTHING!: Eşya bırakın! Bagaj tahliyeyi yavaşlatır.',
        'JUMP AND SLIDE!: Kaydıraktan kay. Beklemeden zıpla.'
      ],
      keyPoints: [
        'BRACE pozisyonu',
        'EVACUATE komutu',
        'Eşya bıraktırın',
        'Net, yüksek ses'
      ]
    }
  },
  'CM-M14-U1-L3': {
    lesson_id: 'CM-M14-U1-L3',
    title: 'Slide ve Raft Kullanımı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Acil Ekipmanlar',
      paragraphs: [
        'Slide: Karada tahliye için. Kapı açılınca otomatik şişer (armed ise).',
        'Raft Mode: Bazı slide\'lar su üzerinde sal olarak kullanılır. Slide/Raft.',
        'Detach: Salı uçaktan ayırma. Batma tehlikesinde zorunlu.',
        'Life Vest: Can yeleği. Koltuk altında. Sadece uçak dışında şişirin!',
        'ELT (Emergency Locator Transmitter): Acil konum vericisi. Otomatik aktif olur.'
      ],
      keyPoints: [
        'Armed = Slide hazır',
        'Slide/Raft çift işlev',
        'Life vest içeride şişirme!',
        'ELT = Konum vericisi'
      ]
    }
  },
  'CM-M14-U1-L4': {
    lesson_id: 'CM-M14-U1-L4',
    title: 'Tahliye Sıralaması',
    type: 'dragdrop',
    duration: 4,
    xp: 40,
    dragdrop: {
      instruction: 'Tahliye adımlarını doğru sıralayın',
      items: [
        { text: '1️⃣ BRACE komutu ver', order: 1 },
        { text: '2️⃣ Kapıyı değerlendir', order: 2 },
        { text: '3️⃣ Kapıyı aç / Slide aktif', order: 3 },
        { text: '4️⃣ EVACUATE komutu ver', order: 4 },
        { text: '5️⃣ Yolcuları yönlendir', order: 5 }
      ]
    }
  },

  // ==================== YANGIN ====================
  'CM-M14-U2-L1': {
    lesson_id: 'CM-M14-U2-L1',
    title: 'Yangın Tipleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Uçakta Yangın Türleri',
      paragraphs: [
        'Class A: Katı maddeler. Kağıt, kumaş, plastik. Su ile söndürülür.',
        'Class B: Yanıcı sıvılar. Yakıt, yağ. Köpük veya CO2 ile.',
        'Class C: Elektrik yangını. Önce elektriği kes! CO2 veya Halon.',
        'Class D: Metal yangını. Uçakta nadir. Özel söndürücü gerekir.',
        'Lithium Battery: Pil yangını. Cep telefonu, laptop. Su + kum torbası ile.'
      ],
      keyPoints: [
        'Class A = Katı (su)',
        'Class B = Sıvı (köpük)',
        'Class C = Elektrik (CO2)',
        'Pil yangını = Su + kum'
      ]
    }
  },
  'CM-M14-U2-L2': {
    lesson_id: 'CM-M14-U2-L2',
    title: 'Söndürücü Kullanımı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Yangın Söndürücü Kullanımı',
      paragraphs: [
        'PASS Yöntemi: Pull (pimi çek), Aim (hedefe nişan al), Squeeze (tetik), Sweep (süpür).',
        'Halon: Çok etkili. Kapalı alanlarda dikkatli kullan. Soluma tehlikeli.',
        'CO2: Elektrik yangınları için. Soğuk çıkar, donmaya dikkat.',
        'Water (H2O): Katı madde yangınları. Elektriğe ASLA!',
        'PBE (Protective Breathing Equipment): Duman maskesi. Yangınla mücadele ederken takın.'
      ],
      keyPoints: [
        'PASS: Pull-Aim-Squeeze-Sweep',
        'Halon = Genel amaçlı',
        'CO2 = Elektrik',
        'PBE = Koruyucu maske'
      ]
    }
  },
  'CM-M14-U2-L3': {
    lesson_id: 'CM-M14-U2-L3',
    title: 'Yangın Senaryosu',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Uçuş sırasında lavatory\'de duman dedektörü alarmı çaldı. Ne yaparsınız?',
      context: 'Siz en yakın kabin memurusunuz.',
      options: [
        { id: 'A', text: 'Kapıyı hızla açıp içeri girerim', isCorrect: false },
        { id: 'B', text: 'PBE takıp, söndürücüyle yaklaşıp kontrollü açarım', isCorrect: true },
        { id: 'C', text: 'Alarmı susturup beklemeye alırım', isCorrect: false },
        { id: 'D', text: 'Kaptanı ararım ve beklerim', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Önce kendinizi koruyun (PBE), ekipmanı alın, sonra kontrollü müdahale edin.',
        wrong: 'Hatalı. Yangına hazırlıksız müdahale tehlikeli. PBE ve söndürücü şart.'
      },
      explanation: 'Lavatory yangını: 1) Ekibi bilgilendir, 2) PBE tak, 3) Söndürücü al, 4) Kontrollü aç, 5) Söndür.'
    }
  },

  // ==================== BASINC KAYBI ====================
  'CM-M14-U3-L1': {
    lesson_id: 'CM-M14-U3-L1',
    title: 'Decompression Tipleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Basınç Kaybı Türleri',
      paragraphs: [
        'Explosive Decompression: Ani ve şiddetli. 1-2 saniyede. Gövde hasarında oluşur.',
        'Rapid Decompression: Hızlı ama explosive kadar şiddetli değil. 1-10 saniye.',
        'Gradual/Slow Decompression: Yavaş sızıntı. Fark edilmesi zor. Tehlikeli!',
        'TUC (Time of Useful Consciousness): Bilincin korunduğu süre. 35,000ft\'de sadece 15-30 saniye!',
        'Belirtiler: Kulak ağrısı, nefes darlığı, görme bulanıklığı, soğuk, sis.'
      ],
      keyPoints: [
        'Explosive = En şiddetli',
        'TUC = Bilinçli kalma süresi',
        'Yüksek irtifada TUC kısa!',
        'Yavaş decompression tehlikeli'
      ]
    }
  },
  'CM-M14-U3-L2': {
    lesson_id: 'CM-M14-U3-L2',
    title: 'Oksijen Maskesi Prosedürü',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Oksijen Maskesi Kullanımı',
      paragraphs: [
        'Önce Kendin!: Kendi maskeni tak, sonra yolculara yardım et. Uçak kuralı!',
        'Drop-Down Masks: PSU\'dan düşer. Çekin ve yüze yerleştirin.',
        'Portable O2: Kabin ekibi için taşınabilir oksijen. Gezinirken kullanılır.',
        'Rezerv: Yolcu maskeleri ~12-15 dakika oksijen sağlar.',
        'Emergency Descent: Pilot acil alçalma yapar. 10,000ft altına inilir.'
      ],
      keyPoints: [
        'ÖNCE KENDİ MASKENİ!',
        '~12-15 dakika oksijen',
        'Portable O2 ekip için',
        'Acil alçalma 10,000ft'
      ]
    }
  },
  'CM-M14-U3-L3': {
    lesson_id: 'CM-M14-U3-L3',
    title: 'Basınç Kaybı Quiz',
    type: 'quiz',
    duration: 5,
    xp: 40,
    quiz: {
      questions: [
        { q: 'TUC ne demek?', options: ['Toplam Uçuş Cıvatası', 'Time of Useful Consciousness', 'Total Unit Count', 'Teknik Uzay Cihazı'], correct: 1 },
        { q: 'Basınç kaybında ilk ne yapılır?', options: ['Yolcuya yardım', 'Kendi maskeni tak', 'Kaptanı ara', 'Otur'], correct: 1 },
        { q: 'Explosive decompression kaç saniye sürer?', options: ['1-2 saniye', '10-30 saniye', '1-2 dakika', '5 dakika'], correct: 0 },
        { q: 'Acil alçalmada hedef irtifa?', options: ['20,000ft', '15,000ft', '10,000ft', '5,000ft'], correct: 2 }
      ]
    }
  },

  // ==================== TIBBİ ACİL ====================
  'CM-M14-U4-L1': {
    lesson_id: 'CM-M14-U4-L1',
    title: 'Temel İlk Yardım',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Uçakta İlk Yardım',
      paragraphs: [
        'First Aid Kit: Temel malzemeler. Bandaj, antiseptik, ağrı kesici, vb.',
        'Emergency Medical Kit: Doktor için. İlaçlar, enjektör, steteskop.',
        'AED (Automated External Defibrillator): Kalp krizi için. Otomatik analiz ve şok.',
        'Is there a doctor on board?: Anons yap. Tıbbi personel ara.',
        'Telemedicine: Bazı havayollarında yer hizmeti ile tıbbi konsultasyon.'
      ],
      keyPoints: [
        'First Aid Kit = Temel',
        'EMK = Doktor için',
        'AED = Kalp şoku',
        'Doktor anonsu yap'
      ]
    }
  },
  'CM-M14-U4-L2': {
    lesson_id: 'CM-M14-U4-L2',
    title: 'CPR ve AED',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'CPR ve AED Kullanımı',
      paragraphs: [
        'CPR (Cardiopulmonary Resuscitation): Kalp masajı + suni solunum.',
        'Oran: 30 basış, 2 solunum. Dakikada 100-120 basış hızı.',
        'Derinlik: 5-6 cm. Göğüs ortasına bas.',
        'AED Kullanımı: Cihazı aç, pedleri yapıştır, sesli talimatları izle.',
        'Önemli: AED analiz yaparken hastaya DOKUNMAYIN!'
      ],
      keyPoints: [
        '30:2 oranı',
        '100-120 basış/dakika',
        '5-6 cm derinlik',
        'AED sesli talimat verir'
      ]
    }
  },
  'CM-M14-U4-L3': {
    lesson_id: 'CM-M14-U4-L3',
    title: 'Yaygın Tıbbi Durumlar',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Sık Karşılaşılan Tıbbi Durumlar',
      paragraphs: [
        'Bayılma (Syncope): En yaygın. Bacakları kaldır, hava ver, sıkı giysiyi gevşet.',
        'Hiperventilasyon: Hızlı nefes. Kağıt poşete soluttur. Sakinleştir.',
        'Epilepsi Nöbeti: Koruma pozisyonu. Ağzına bir şey koyma! Zamanla.',
        'Alerjik Reaksiyon: Anafilaksi ciddi. EpiPen (epinefrin) gerekebilir.',
        'Diyabetik Kriz: Şeker düşüklüğü. Şekerli içecek ver (bilinçli ise).'
      ],
      keyPoints: [
        'Bayılma = Bacak kaldır',
        'Hiperventilasyon = Kağıt poşet',
        'Epilepsi = Ağza bir şey koyma',
        'Diyabet = Şeker ver'
      ]
    }
  },
  'CM-M14-U4-L4': {
    lesson_id: 'CM-M14-U4-L4',
    title: 'Tıbbi Senaryo',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Yolcu birden göğsünü tuttu ve bilinç kaybetti. Nabız yok. Ne yaparsınız?',
      context: 'Uçuş ortasında, en yakın tesisat 2 saat uzakta.',
      options: [
        { id: 'A', text: 'Hemen CPR başlat ve AED getir', isCorrect: true },
        { id: 'B', text: 'Sadece doktor anonsu yap, bekle', isCorrect: false },
        { id: 'C', text: 'Yolcuyu recovery pozisyonuna al', isCorrect: false },
        { id: 'D', text: 'Oksijen maskesi tak ve izle', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Nabız yoksa HEMEN CPR. Saniyeler önemli. AED\'yi birisi getirsin.',
        wrong: 'Hatalı. Nabız yoksa acil CPR gerekli. Beklemek ölüm demek olabilir.'
      },
      explanation: 'Kalp durmasında: 1) Yardım çağır, 2) CPR başlat, 3) AED getirt, 4) Doktor anonsu, 5) Divert düşün.'
    }
  },

  // ==================== GÜVENLİK ====================
  'CM-M14-U5-L1': {
    lesson_id: 'CM-M14-U5-L1',
    title: 'Güvenlik Prosedürleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Güvenlik Tehditleri',
      paragraphs: [
        'Hijack (Kaçırma): Kaptan\'a erişimi engelle. Gizli kod kullan. Sakin kal.',
        'Bomb Threat: Ciddi al. Yolcuyu izole et. Bilgiyi kokpite ilet.',
        'Unruly Passenger: Agresif yolcu. De-escalation dene. Gerekirse restraint.',
        'Suspicious Item: Şüpheli paket. Dokunma! Bulunduğu yerde bırak. Raporla.',
        'Sterile Cockpit: Kalkış/inişte kokpite gereksiz giriş yok. Güvenlik kuralı.'
      ],
      keyPoints: [
        'Kaçırma = Gizli kod',
        'Bomba = Dokunma',
        'Agresif = De-escalation',
        'Sterile cockpit kuralı'
      ]
    }
  },
  'CM-M14-U5-L2': {
    lesson_id: 'CM-M14-U5-L2',
    title: 'Şüpheli Durum Yönetimi',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Şüpheli Durumları Yönetme',
      paragraphs: [
        'Gözlem: Şüpheli davranışları izle. Ter, sinirlilik, kılık kıyafet, bagaj.',
        'Raporlama: Kokpite bildir. Net ve sakin konuş. Abartma.',
        'Dikkatsiz Görünme: Anlaşıldığını belli etme. Normal davran.',
        'En Az Dikkat Çek: Diğer yolcuları panikletme.',
        'Restraint: Plastik kelepce, uzatma kemeri. Son çare. Yasal destek gerekir.'
      ],
      keyPoints: [
        'İzle ve raporla',
        'Kokpiti bilgilendir',
        'Panik yaratma',
        'Restraint = Son çare'
      ]
    }
  },
  'CM-M14-U5-L3': {
    lesson_id: 'CM-M14-U5-L3',
    title: 'Güvenlik Senaryosu',
    type: 'scenario',
    duration: 8,
    xp: 45,
    scenario: {
      question: 'Yolcu lavatory\'de uzun süre kalıyor ve tıkırtı sesleri geliyor. Ne yaparsınız?',
      context: 'Uçuş ortası, okyanusun üzerinde.',
      options: [
        { id: 'A', text: 'Kapıyı zorla açıp bakarım', isCorrect: false },
        { id: 'B', text: 'Kibarca kapıyı çalar, cevap beklerim, kokpiti bilgilendiririm', isCorrect: true },
        { id: 'C', text: 'Görmezden gelirim', isCorrect: false },
        { id: 'D', text: 'Diğer yolculara sorarm', isCorrect: false }
      ],
      feedback: {
        correct: 'Doğru! Önce kibarca kontrol, sakin değerlendir, kokpiti bilgilendir.',
        wrong: 'Hatalı. Ne görmezden gel, ne de zorla aç. Prosedüre uy.'
      },
      explanation: 'Adım adım: 1) Kapıyı çal, 2) Cevabı dinle, 3) Cockpit\'i bilgilendir, 4) Talimat bekle.'
    }
  },

  // ==================== ACİL DURUM OYUNLARI ====================
  'CM-M14-U6-L1': {
    lesson_id: 'CM-M14-U6-L1',
    title: 'Acil Durum Yarışı',
    type: 'timerace',
    duration: 5,
    xp: 60,
    timerace: {
      timePerQuestion: 7,
      questions: [
        { q: 'Basınç kaybında ilk ne yapılır?', options: ['Yolcuya yardım', 'Kendi maskeni tak', 'Kaptanı ara', 'Otur'], correct: 1 },
        { q: 'CPR oranı nedir?', options: ['15:2', '30:2', '30:1', '20:2'], correct: 1 },
        { q: 'Elektrik yangınında hangi söndürücü?', options: ['Su', 'Köpük', 'CO2', 'Kum'], correct: 2 },
        { q: 'TUC ne demek?', options: ['Total Unit', 'Time of Useful Consciousness', 'Technical', 'Transfer'], correct: 1 },
        { q: 'Tahliyede yolcu ne bırakmalı?', options: ['Pasaport', 'Telefon', 'Her şeyi', 'Hiçbir şey'], correct: 2 },
        { q: 'AED ne için?', options: ['Solunum', 'Kalp', 'Kırık', 'Yanık'], correct: 1 }
      ]
    }
  },
  'CM-M14-U6-L2': {
    lesson_id: 'CM-M14-U6-L2',
    title: 'Doğru/Yanlış: Acil',
    type: 'truefalse',
    duration: 4,
    xp: 40,
    truefalse: {
      statements: [
        { statement: 'Basınç kaybında önce yolcuya yardım edilir.', isTrue: false, explanation: 'Yanlış! Önce kendi maskeni tak!' },
        { statement: '90 saniyede tüm yolcular tahliye edilebilmeli.', isTrue: true, explanation: 'Doğru! Yasal zorunluluk.' },
        { statement: 'Life vest uçak içinde şişirilir.', isTrue: false, explanation: 'Yanlış! Sadece uçak DİŞINDA şişirin.' },
        { statement: 'CPR\'da dakikada 60 basış yapılır.', isTrue: false, explanation: 'Yanlış! 100-120 basış/dakika.' },
        { statement: 'Bomb threat ciddi alınır.', isTrue: true, explanation: 'Doğru! Her tehdit ciddi.' }
      ]
    }
  }
};

export default cabinCrewContentsM14;
